//import { createMuiTheme } from "@mui/material";
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material";

declare module '@mui/material/styles/adaptV4Theme' {
    interface DeprecatedThemeOptions {
        deloitte: {
            accessible: string,
            hover: string,
            brand: string,
            blue: string,
            red: string,
            menuSize: number,
            radius:string
        }
    }
}
declare module '@mui/material/styles/createTheme' {
    interface Theme {
        deloitte: {
            accessible: string,
            hover: string,
            brand: string,
            blue: string,
            red: string,
            menuSize: number,
            radius:string
        }
    }
    interface ThemeOptions {
        deloitte: {
            accessible: string,
            hover: string,
            brand: string,
            blue: string,
            red: string,
            menuSize: number,
            radius: string
        }
    }
}

export const DarkTheme = createMuiTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#000000',
            paper: '#23252c'
        },
        primary: {
            light: '#23252c',
            main: '#000000',
            dark: '#000000',
            contrastText: '#fff'
        },
        secondary: {
            light: '#9ec950',
            main: '#86bc25',
            dark: '#5d8319',
            contrastText: '#000',
        }
    },
    typography: {
        fontFamily: [
            'Open Sans',
            'sans-serif',
        ].join(',')
    },
    deloitte: {
        accessible: '#26890D',
        hover: '#43b02a',
        brand: '#86bc25',
        blue: '#007CB0',
        red: '#DA291C',
        menuSize: 66,
        radius:'4px'
    },
    components: {
        MuiLink: {
            defaultProps: {
                underline: 'hover',
            },
        }
    }
});

export const LightTheme = createMuiTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#86bc25',
            light: '#9ec950',
        },
        background: {
            default: '#F0F0F3',
            paper: '#FFFFFF'
        },
        secondary: {
            main: '#86bc25',
            dark: '#5d8319',
            contrastText: '#000',
        }
    },
    typography: {
        fontFamily: [
            'Open Sans',
            'sans-serif',
        ].join(',')
    },
    deloitte: {
        accessible: '#26890D',
        hover: '#43b02a',
        brand: '#86bc25',
        blue: '#007CB0',
        red: '#DA291C',
        menuSize: 66,
        radius: '4px'
    },
    components: {
        MuiLink: {
            defaultProps: {
                underline: 'hover',
            },
        }
    }
});